import { Component } from '@angular/core';

/// Routed-to component when nothing matches.
@Component({
    template: `<h1 class="text-center">Sorry! That page doesn't seem to exist.</h1>`
})
export class PageNotFoundComponent {
}
